module.exports = __webpack_public_path__ + "media/components/assets/telegram_icon-6d96286f0e80e4247131dec12e88af68.svg";